import axios from 'axios';
import moment from 'moment';

import {
    calculateStartDate,
    findLatestTradingTime,
    getStartTimestampPeriod,
    getTimestampPeriod,
    klineArrayToObject,
    periodMinutesToString,
} from './helpers'

const makeHistoryUrl = (market, resolution, from, to, countBack) => {
    const payload = {
        frequency: periodMinutesToString(resolution),
        start: getTimestampPeriod(from, resolution),
        stop: getTimestampPeriod(to, resolution),
    };
    let endPoint = 'api/enduser/public/kline';
    if (payload) {
        // endPoint = `https://www.corex.mn/api/v2/peatio/public/markets/crxmnt/k-line?period=${resolution}&time_from=${getTimestampPeriod(from, resolution)}&time_to=${getTimestampPeriod(to, resolution)}`
        endPoint = `${endPoint}?frequency=${periodMinutesToString(resolution)}&start=${getTimestampPeriod(from, resolution)}&stop=${getTimestampPeriod(to, resolution)}&symbol=${market}&count=${countBack}`;
    }
    return `${endPoint}`;
};
const resolutionToMinutes = function (r) {
    const minutes = parseInt(r, 10);
    if (r === '1D') {
        return 1440;
    } else if (r === 'D') {
        return 4320;
    } else if (!isNaN(minutes)) {
        return minutes;
    } else {
        return 1;
    }
};

const config = {
    supports_timescale_marks: true,
    supports_time: true,
    // supported_resolutions: ['1', '15', '30', '60', '120', '240', 'd'],
    supported_resolutions: ['15', '30', '60', 'd'],
};

export const dataFeedObject = (tradingChart, markets) => {
    const dataFeed = {
        onReady: cb => {
            setTimeout(() => cb(config), 0);
        },
        resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
            if (tradingChart.resolveSymbolTimeout !== null) {
                clearTimeout(tradingChart.resolveSymbolTimeout)
                tradingChart.resolveSymbolTimeout = null
                tradingChart.clearRecentBarValues()
            }

            console.debug('(api.js) DataFeed resolve symbol begins ...')

            const symbol = markets[0];
            console.debug('Markets: ' + markets)
            if (!symbol) {
                return setTimeout(() => onResolveErrorCallback('Symbol not found'), 0);
            }
            const symbolStub = {
                name: symbol.symbol,
                currency_code: "tugrik",
                description: symbol.company_name ? symbol.company_name : symbol.company_symbol_name,
                type: 'stock',
                session: '0900-2200',
                // timezone: 'Asia/Hong_Kong',
                timezone: 'Asia/Hong_Kong',
                ticker: symbol.id.toString(),
                minmov: 1,
                pricescale: 100,
                has_intraday: true,
                disable_resolution_rebuild: false,
                intraday_multipliers: ['1', '5', '15', '30', '60', '120', '240', '360', '720', 'd'],
                supported_resolutions: ['1', '5', '15', '30', '60', '120', '240', '360', '720', 'd'],
                volume_precision: 2,
                data_status: 'endofday',
            }
            tradingChart.resolveSymbolTimeout = setTimeout(() => onSymbolResolvedCallback(symbolStub), 0)
            return tradingChart.resolveSymbolTimeout
        },
        getBars: async (
            symbolInfo,
            resolution,
            range,
            onHistoryCallback,
            onErrorCallback,
            firstDataRequest,
        ) => {
            if (tradingChart.brand.symbol === symbolInfo.name) {
                const { from, to, countBack, firstDataRequest } = range
                const finalTo = findLatestTradingTime(to, resolution, firstDataRequest, tradingChart.brand.exchange_server_code)
                const finalFrom = calculateStartDate(from, to, finalTo)
                let count = parseInt((getStartTimestampPeriod(finalTo, resolution) - getStartTimestampPeriod(finalFrom, resolution)) / (resolutionToMinutes(resolution) * 60)) + 1
                const rangeFrom = getStartTimestampPeriod(finalTo, resolution);
                // console.debug('(api.js) About to fetch symbol: ', symbolInfo);
                // console.debug('(api.js) from', from);
                // console.debug('(api.js) to', to);
                const url = makeHistoryUrl(
                  symbolInfo.name,
                  resolutionToMinutes(resolution),
                  finalFrom,
                  finalTo,
                  countBack
                );

                return axios
                  .get(url)
                  .then(({ data }) => {
                      // console.debug('(api.js) getBars -> data: ', data)
                      if(tradingChart.brand.stype === 2 && (tradingChart.brand.brand_bond?.bond_type === 100)){
                        data.forEach(d => {
                          d[1] = d[1] * 1000
                          d[2] = d[2] * 1000
                          d[3] = d[3] * 1000
                          d[4] = d[4] * 1000
                      })}
                      if (data.length < 1) {
                          return onHistoryCallback([], { noData: true });
                      }
                      const bars = data.map(klineArrayToObject);
                      let recent = _.cloneDeep(bars[bars.length - 1]);
                      console.debug('(api.js) getBars -> recent: ', recent);
                      tradingChart.allBars.push(recent);
                      console.debug('(api.js) getBars -> tradingChart.allBars: ', tradingChart.allBars);
                      if (tradingChart.mostRecentBar === null)
                          tradingChart.mostRecentBar = tradingChart.allBars[0];
                      if (resolutionToMinutes(resolution) * 60000 !== tradingChart.recentResolution)
                          tradingChart.mostRecentBar = _.cloneDeep(tradingChart.allBars[0]);
                      if (tradingChart.allBars[0].time > tradingChart.mostRecentBar.time)
                          tradingChart.mostRecentBar = _.cloneDeep(tradingChart.allBars[0]);

                      return onHistoryCallback(bars, { noData: false });
                  })
                  .catch(e => {
                      return onHistoryCallback([], { noData: true });
                  });
            }
        },
        subscribeBars: (
            symbolInfo,
            resolution,
            onRealtimeCallback,
            subscribeUID,
            onResetCacheNeededCallback,
        ) => {
            tradingChart.realTimeCallBack = onRealtimeCallback
            // tradingChart.cent(onRealtimeCallback)
            // tradingChart.appendNewTrade(onRealtimeCallback)
            // tradingChart.timedEvent(onRealtimeCallback, resolutionToMinutes(resolution) * 60000)
        },
        unsubscribeBars: async (
          subscribeUID,
        ) => {
            // await tradingChart.unsubscribeCent()
            tradingChart.clearRecentBarValues()
            tradingChart.unsubscribeTimedEvent()
        }
    };

    return dataFeed;
};
